import { RepositoryFactory } from "@/data/repositories/repositoryFactory";

const state = {
    batches: [],
    totalCount: 0,
    loading: false,
    error: null,
    searchParams: {},
    options: {
        page: 1,
        itemsPerPage: 50
    },
    summary: null,
    summaryLoading: false,
    summaryError: null
};

const getters = {
    batches: state => state.batches,
    totalCount: state => state.totalCount,
    loading: state => state.loading,
    searchParams: state => state.searchParams,
    summary: state => state.summary,
    summaryLoading: state => state.summaryLoading
};

const actions = {
    async searchBatches({ commit, state }) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);
        try {
            const params = {
                ...state.searchParams,
                Top: state.options.itemsPerPage,
                Page: state.options.page
            };
            const response = await RepositoryFactory.get("kelaBatch").search(params);
            commit("SET_BATCHES", response.data.results || response.data);
            commit("SET_TOTAL_COUNT", response.data.totalCount || 0);
        } catch (error) {
            commit("SET_ERROR", error.message || "Kela-erien haku epäonnistui");
        } finally {
            commit("SET_LOADING", false);
        }
    },

    async loadPage({ commit, dispatch }, page) {
        commit("SET_PAGE", page);
        await dispatch("searchBatches");
    },

    async updateOptions({ commit, dispatch }, options) {
        commit("SET_OPTIONS", options);
        await dispatch("searchBatches");
    },

    async setSearchParams({ commit, dispatch }, params) {
        commit("SET_SEARCH_PARAMS", params);
        commit("SET_PAGE", 1);
        await dispatch("searchBatches");
    },

    async setTransportEventFilter({ commit, dispatch }, transportEventId) {
        commit("SET_SEARCH_PARAMS", { TransportEventId: transportEventId });
        commit("SET_PAGE", 1);
        await dispatch("searchBatches");
    },

    async fetchSummary({ commit }) {
        commit("SET_SUMMARY_LOADING", true);
        commit("SET_SUMMARY_ERROR", null);
        try {
            const response = await RepositoryFactory.get("kelaBatch").getSummary();
            commit("SET_SUMMARY", response.data);
        } catch (error) {
            commit("SET_SUMMARY_ERROR", error.message);
        } finally {
            commit("SET_SUMMARY_LOADING", false);
        }
    }
};

const mutations = {
    SET_BATCHES(state, batches) {
        state.batches = batches;
    },
    SET_TOTAL_COUNT(state, count) {
        state.totalCount = count;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    SET_SEARCH_PARAMS(state, params) {
        state.searchParams = params;
    },
    SET_OPTIONS(state, options) {
        Object.assign(state.options, options);
    },
    SET_PAGE(state, page) {
        state.options.page = page;
    },
    SET_SUMMARY(state, summary) {
        state.summary = summary;
    },
    SET_SUMMARY_LOADING(state, loading) {
        state.summaryLoading = loading;
    },
    SET_SUMMARY_ERROR(state, error) {
        state.summaryError = error;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
